<div class="patrol-auth-page">
  <div class="patrol-auth-card">
    <div class="patrol-auth-header">
      <img
        class="patrol-auth-logo"
        src="/public/svgs/patrol-w.svg"
        alt="Valvur Patrol"
      />
      <h1 class="patrol-auth-title">{{ 'app.patrol.auth.title' | translate }}</h1>
      <p class="patrol-auth-subtitle">
        {{ 'app.patrol.auth.subtitle' | translate }}
      </p>
    </div>

    <section class="patrol-auth-form">
      <app-patrol-signin-form
        [requestPending]="isPending()"
        (formSubmitted)="handleSignin($event)"
      ></app-patrol-signin-form>
    </section>
  </div>
</div>
